import React from "react";
import { SvgIcon } from "@mui/material";

const DatabaseIcon = ({
  width = "16",
  height = "21",
  viewBox = "0 0 16 21",
  stroke = "#4D44D8",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.03785 10.0752V15.724C1.03785 17.5959 4.07273 19.1133 7.81641 19.1133C11.5601 19.1133 14.595 17.5959 14.595 15.724V10.0752M1.03785 10.0752V4.42639M1.03785 10.0752C1.03785 11.9471 4.07273 13.4645 7.81641 13.4645C11.5601 13.4645 14.595 11.9471 14.595 10.0752M14.595 10.0752V4.42639M1.03785 4.42639C1.03785 2.55455 4.07273 1.03711 7.81641 1.03711C11.5601 1.03711 14.595 2.55455 14.595 4.42639M1.03785 4.42639C1.03785 6.29823 4.07273 7.81567 7.81641 7.81567C11.5601 7.81567 14.595 6.29823 14.595 4.42639"
      stroke={stroke}
      stroke-width="2.07581"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default DatabaseIcon;
